export enum AppName {
  tmsWeb = 'TMS Web',
}
